SparkleVersion = '3.36';